let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5I6km")).then(() => parcelRequire('9xBAG'));